import IztPopup from './src/izt-popup'

IztPopup.install = Vue => {
  Vue.component(IztPopup.name, IztPopup)
}

export default IztPopup
